module.exports = __webpack_public_path__ + "static/img/lqm.335b93b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/lqm.png
// module id = hiwx
// module chunks = 18